<template>
  <div id="dados-grid-view" class="data-list-container">
    <vs-popup fullscreen title="Lista de Arquivos de Vídeo" v-if="popupListaArquivos.popupActive" :active.sync="popupListaArquivos.popupActive">
      <div class="flex w-full justify-between"> 
        <h6> Veículo: {{popupListaArquivos.tr.placa}}</h6>
        <h6> Câmera: {{popupListaArquivos.numeroCamera}}</h6>
      </div>
      <div class="flex mt-2 mb-2 justify-between">        
        <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-upload" @click="requisitarNovaListaArquivosVideo(popupListaArquivos.tr,popupListaArquivos.numeroCamera)">Requisitar Lista de Arquivos para Camera</vs-button>
        <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-refresh-cw" @click="exibirUltimaLista(popupListaArquivos.tr,popupListaArquivos.numeroCamera)">Exibir Ultima Lista</vs-button>
      </div>
      <small> Arquivos : <strong>{{popupListaArquivos.listaArquivosVideo.length}}</strong> </small>
      <div> 
       <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="popupListaArquivos.listaArquivosVideo"
        :headerHeight="25"        
        rowSelection="single"
        colResizeDefault="shift"        
        :animateRows="false"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        :context="configuracaoGrid.context" 
        @grid-ready="onGridReady"
      />
      </div>


     
    </vs-popup>

    <div class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">          
          <div class="p-3 mb-4 mr-4 flex items-center justify-center font-large font-bold">  
            <vx-tooltip :text="$t('Tooltip_Qtd_Veiculos')">              
              <h2 class="text-success">{{queriedItems}}</h2>
            </vx-tooltip>
          </div>          
                    
          <div class="p-3 mb-4">                                                   
              <v-select 
                  label="nome" 
                  :reduce="divisao => divisao.nome" 
                  :options="listaDivisao" 
                  v-model="cmbDivisao"
                  style="min-width: 215px"                  
                  :placeholder="$t('Divisao')"></v-select>
          </div>          
                    
          <div class="p-3 mb-4 mr-4 flex items-center justify-center font-medium">                            
              <vx-input-group>     
                    <input class="vs-input--input w-full" type="text"  style="min-width: 172px; line-height: 24px;" name="txtTermoPesquisa" id="txtTermoPesquisa" ref="txtTermoPesquisa"  v-on:keyup.13="pesquisarPorTermo($refs.txtTermoPesquisa.value)"/> 
                    <template slot="append">
                        <div class="append-text btn-addon">
                            <vs-button color="dark" icon-pack="feather" icon="icon-search" @click="pesquisarPorTermo($refs.txtTermoPesquisa.value)"></vs-button>                                                
                        </div>
                    </template>
              </vx-input-group>
          </div>
                 
        </div>       
    </div>

    <div class="-mt-4">          
          <vs-alert color="danger" title="Atenção" :active.sync="popUpCameras.exibirMensagem" closable icon-pack="feather" close-icon="icon-x">
                {{popUpCameras.mensagem}}
          </vs-alert>                                                              
          <div class="flex justify-center w-full mt-2">
              <div class="mr-2">
                  <div class="flex items-center">
                    <div class="ml-auto loaderDIV justify-center" v-if="isLoading1"></div>
                    <h6 class="text-primary w-full text-center"> {{popUpCameras.labelCamera1}} </h6>
                    <vs-button color="primary" icon-pack="feather" icon="icon-x-square" size="small" @click="pararCamera(1)" v-if="popUpCameras.camera1" class="ml-auto"></vs-button>                 
                  </div>
                  <vue-flv-player key="`player_1" ref="refPlayer_1" type="flv" :width="200" :height="150" autoplay :isLive="true" controls :muted="true"  :source="popUpCameras.camera1"/> 
                  
              </div>
              <div class="mr-2">
                <div class="flex items-center">
                    <div class="ml-auto loaderDIV justify-center" v-if="isLoading2"></div>
                    <h6 class="text-primary w-full text-center"> {{popUpCameras.labelCamera2}} </h6>
                    <vs-button color="primary" icon-pack="feather" icon="icon-x-square" size="small" @click="pararCamera(2)" v-if="popUpCameras.camera2" class="ml-auto"></vs-button>                 
                  </div>
                  <vue-flv-player key="`player_2" ref="refPlayer_2" type="flv" :width="200" :height="150" autoplay :isLive="true" controls :muted="true" :source="popUpCameras.camera2"/>                  
                  
              </div>
              <div class="mr-2">
                  <div class="flex items-center">
                    <div class="ml-auto loaderDIV justify-center" v-if="isLoading3"></div>
                    <h6 class="text-primary w-full text-center"> {{popUpCameras.labelCamera3}} </h6>
                    <vs-button color="primary" icon-pack="feather" icon="icon-x-square" size="small" @click="pararCamera(3)" v-if="popUpCameras.camera3" class="ml-auto"></vs-button>                 
                  </div>
                  <vue-flv-player key="player_3" ref="refPlayer_3" type="flv"  :width="200" :height="150" autoplay :isLive="true" controls :muted="true" :source="popUpCameras.camera3"/>                  
                  
              </div>         
              <div class="mr-2">
                  <div class="flex items-center">
                    <div class="ml-auto loaderDIV justify-center" v-if="isLoading4"></div>
                    <h6 class="text-primary w-full text-center"> {{popUpCameras.labelCamera4}} </h6>
                    <vs-button color="primary" icon-pack="feather" icon="icon-x-square" size="small" @click="pararCamera(4)" v-if="popUpCameras.camera4" class="ml-auto"></vs-button>                 
                  </div>
                  <vue-flv-player key="player_4" ref="refPlayer_4" type="flv"  :width="200" :height="150" autoplay :isLive="true" controls :muted="true" :source="popUpCameras.camera4"/>                  
                  
              </div>
              <div>
                  <div class="flex items-center">
                    <div class="ml-auto loaderDIV justify-center" v-if="isLoading5"></div>
                    <h6 class="text-primary w-full text-center"> {{popUpCameras.labelCamera5}} </h6>
                    <vs-button color="primary" icon-pack="feather" icon="icon-x-square" size="small" @click="pararCamera(5)" v-if="popUpCameras.camera5" class="ml-auto"></vs-button>                 
                  </div>
                  <vue-flv-player key="player_5" ref="refPlayer_5" type="flv"  :width="200" :height="150" autoplay :isLive="true" controls :muted="true" :source="popUpCameras.camera5"/>                  
                  
              </div>
          </div>      
    </div>    
    <div class="tabelaComScroll">
      <vs-table ref="table" :data="filteredVeiculos" :hoverFlat="true" noDataText="..." :sst="true"  @sort="ordenarTabela">
            <template slot="thead">         
              <vs-th v-if="colunasGrid.veiculo" sort-key="modelo"><span style="font-size: x-small">{{ $t('Veiculo') }}</span></vs-th>
              <vs-th v-if="colunasGrid.ignicaoBloqueio"></vs-th>
              <vs-th v-if="colunasGrid.statusConexaoStatusAlimentacao"></vs-th>
              <vs-th v-if="colunasGrid.placaKmHorimetro" sort-key="placa"><span style="font-size: x-small">{{ $t('Placa') }}</span></vs-th>
              <vs-th v-if="colunasGrid.motorista" sort-key="condutor"><span style="font-size: x-small">{{ $t('Motorista') }}</span></vs-th>
              <vs-th v-if="colunasGrid.velocidadeTempoParado"> <span style="font-size: x-small"> {{ $t('KmhParado')}}</span></vs-th>            
              <vs-th v-if="colunasGrid.localizacaoUltimaAtualizacao" sort-key="cidadeAtual" style="min-width: 150px;"><span style="font-size: x-small">{{ $t('Localizacao') }}</span></vs-th>                                    
            </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :style="getCorLinha(tr)" >

                  <vs-td v-html="getLabelDadosDivisao(tr)" v-if="colunasGrid.veiculo">                
                  </vs-td>
                  <vs-td v-if="colunasGrid.ignicaoBloqueio">
                    <vx-tooltip v-bind:text="'Veículo ligado  - voltagem ' + tr.ultimaVoltagem + 'v'">                
                      <feather-icon icon="CircleIcon" svgClasses="w-3 h-3 fill-current text-success" class="ml-2"  v-if="tr.ignicao === 'LIGADO' && tr.velocidadeAtual > 0" />
                    </vx-tooltip>
                    <vx-tooltip v-bind:text="'Veículo ligado e parado - voltagem ' + tr.ultimaVoltagem + 'v'">                
                      <feather-icon icon="CircleIcon" svgClasses="w-3 h-3 fill-current text-warning" class="ml-2"  v-if="tr.ignicao === 'LIGADO' && tr.velocidadeAtual === 0" />
                    </vx-tooltip>
                    <vx-tooltip text="Veículo desligado">                
                      <feather-icon icon="CircleIcon" svgClasses="w-3 h-3 fill-current text-danger" class="ml-2"  v-if="tr.ignicao === 'DESLIGADO'" />
                    </vx-tooltip>
                    <vx-tooltip text="Veículo bloqueado">                
                      <feather-icon icon="LockIcon" svgClasses="w-3 h-3 stroke-current text-danger" class="ml-2"  v-if="tr.isBloqueado" />
                    </vx-tooltip>
                    <vx-tooltip text="Veículo desbloqueado">                
                      <feather-icon icon="UnlockIcon" svgClasses="w-3 h-3 stroke-current" class="ml-2" :class="corCadeado"  v-if="!tr.isBloqueado" />
                    </vx-tooltip>
                  </vs-td>

                  <vs-td v-if="colunasGrid.statusConexaoStatusAlimentacao">                
                    <vx-tooltip text="Comunicação atualizada">                
                        <feather-icon icon="WifiIcon" svgClasses="w-4 h-4 fill-current text-success" v-if="!tr.isDesatualizado && !tr.moduloPrincipalSat && tr.statusGPRS === 'ON'" />
                    </vx-tooltip>  
                    <vx-tooltip v-bind:text="'Sem transmissão há ' + tr.tempoSemGPRS" >                
                        <feather-icon icon="WifiIcon" svgClasses="w-4 h-4 fill-current text-danger" v-if="!tr.isDesatualizado && !tr.moduloPrincipalSat && tr.statusGPRS === 'OFF'" />
                    </vx-tooltip>  
                    <vx-tooltip text="Comunicação atualizada">                
                        <vs-icon icon="settings_input_antenna" v-if="!tr.isDesatualizado && tr.moduloPrincipalSat && tr.statusGPRS === 'ON'" size="small" color="rgb(70, 150, 0)" ></vs-icon>
                    </vx-tooltip>  
                    <vx-tooltip v-bind:text="'Sem transmissão há ' + tr.tempoSemGPRS" >                
                        <vs-icon icon="settings_input_antenna" v-if="!tr.isDesatualizado && tr.moduloPrincipalSat && tr.statusGPRS === 'OFF'" size="small" color="rgb(255, 0, 0)"></vs-icon>
                    </vx-tooltip>
                    <vx-tooltip v-bind:text="'Veículo desatualizado. Sem transmissão há ' + tr.tempoSemGPRS">                
                        <feather-icon icon="AlertCircleIcon" svgClasses="w-4 h-4 stroke-current text-warning"  v-if="tr.isDesatualizado" />
                    </vx-tooltip>         
                    <vx-tooltip text="Sem alimentação externa">                
                        <feather-icon icon="ZapOffIcon" svgClasses="w-4 h-4 stroke-current text-danger"  v-if="tr.semAlimentacaoExterna" />
                    </vx-tooltip>         
                  </vs-td>

                  <vs-td v-html="getLabelDadosPlaca(tr)" v-if="colunasGrid.placaKmHorimetro"> </vs-td>

                  <vs-td v-if="colunasGrid.motorista">
                    <p style="font-size:small">{{ tr.condutor }}</p>
                  </vs-td>

                  <vs-td v-if="colunasGrid.velocidadeTempoParado">                               
                    <p class="text-center" style="font-size:small">  
                      <vs-icon icon="speed" v-if="isMovendo(tr)" size="small" color="rgb(70, 150, 0)"></vs-icon> 
                      <vs-icon icon="pan_tool" color="rgb(255, 130, 0)" v-else :class="{ clsAlertaTempoParado: tr.hasOwnProperty('exibirAltertaMovimento') }"></vs-icon> 
                    </p>
                    <p class="text-center" style="font-size:small">{{ getLabelVelocidadeEParado(tr) }}</p>
                    <p class="text-center" style="font-size:x-small" v-on:click="click_ExibiVeiculo(tr.placa)">  
                        <vs-icon icon="speed" v-if="isPossuiRPM(tr)" size="small" color="blue"></vs-icon> 
                    </p>
                    <p class="text-center" v-if="isPossuiRPM(tr)" style="font-size:x-small">{{ tr.ultimoRPM }} rpm</p>                                            
                  </vs-td>

                  <vs-td v-if="colunasGrid.localizacaoUltimaAtualizacao">                  
                      <p style='font-size:small'>{{ getLabelLocalizacao(tr) }}</p>
                      <p style='font-size:x-small'>{{ getDataUltimaAtualizacao(tr) }}</p>                  
                  </vs-td>
                  <template slot="expand">
                    <div class="flex items-center">
                      <vx-tooltip text="Visualizar video ao vivo da camera 1.">
                        <vs-button v-if="tr.qtdCameras > 0" size="small" color="primary" type="filled" icon-pack="feather" icon="icon-video" @click="abrirCamera(tr,1)">Camera 1</vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Visualizar videos gravados da camera 1.">
                        <vs-button v-if="tr.qtdCameras > 0" size="small" color="warning" type="filled" icon-pack="feather" icon="icon-list"  @click="abrirPopUp(tr,1)" class="mr-2"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip text="Visualizar video ao vivo da camera 2.">
                        <vs-button v-if="tr.qtdCameras > 1" size="small" color="primary" type="filled" icon-pack="feather" icon="icon-video" @click="abrirCamera(tr,2)">Camera 2</vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Visualizar videos gravados da camera 2.">
                        <vs-button v-if="tr.qtdCameras > 1 && tr.modeloCamera !== 'JC400D'" size="small" color="warning" type="filled" icon-pack="feather" icon="icon-list"  @click="abrirPopUp(tr,2)" class="mr-2"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip text="Visualizar video ao vivo da camera 3.">
                        <vs-button v-if="tr.qtdCameras > 2" size="small" color="primary" type="filled" icon-pack="feather" icon="icon-video" @click="abrirCamera(tr,3)">Camera 3</vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Visualizar videos gravados da camera 3.">
                        <vs-button v-if="tr.qtdCameras > 2" size="small" color="warning" type="filled" icon-pack="feather" icon="icon-list"  @click="abrirPopUp(tr,3)" class="mr-2"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip text="Visualizar video ao vivo da camera 4.">
                        <vs-button v-if="tr.qtdCameras > 3" size="small" color="primary" type="filled" icon-pack="feather" icon="icon-video" @click="abrirCamera(tr,4)">Camera 4</vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Visualizar videos gravados da camera 4.">
                        <vs-button v-if="tr.qtdCameras > 3" size="small" color="warning" type="filled" icon-pack="feather" icon="icon-list"  @click="abrirPopUp(tr,4)" class="mr-2"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip text="Visualizar video ao vivo da camera 5.">
                        <vs-button v-if="tr.qtdCameras > 4" size="small" color="primary" type="filled" icon-pack="feather" icon="icon-video" @click="abrirCamera(tr,5)">Camera 5</vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Visualizar videos gravados da camera 5.">
                        <vs-button v-if="tr.qtdCameras > 4" size="small" color="warning" type="filled" icon-pack="feather" icon="icon-list"  @click="abrirPopUp(tr,5)"></vs-button>
                      </vx-tooltip>
                    </div>
                  </template>
    
                </vs-tr>
              </tbody>
            </template>
      </vs-table>
    </div>
    
  </div>
</template>

<script>

import generico from '@/generico.js'
import axios from "@/axios.js"
import vueFlvPlayer from 'vue-flv-player'
import { AgGridVue } from "ag-grid-vue"
import '@/assets/concept/scss/tabelaBasica.scss'
import BtnAggridDownloadComponentRenderer from './BtnAggridDownloadComponent.vue';
import BtnAggridRequestComponentRenderer from './BtnAggridRequestComponent.vue';

export default {  
  components: {
    AgGridVue,
    vueFlvPlayer,
    BtnAggridDownloadComponentRenderer,
    BtnAggridRequestComponentRenderer
  },
  data() {
    return {    
      configuracaoGrid: { 
          context: null,
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true, wrapText: true, autoHeight: true,  cellStyle: {"wordBreak": "normal"} },
          columnDefs: [        
            { headerName: '#', valueGetter: "node.rowIndex + 1", width: 40 },     
            { headerName: 'INICIO', field: 'beginTimeFormatado', width: 120},                 
            { headerName: 'FIM', field: 'endTimeFormatado', width: 120 },                 
            { headerName: 'DATA DA LISTA', field: 'dataHoraCriadoFormatada', width: 120 },                 
            { headerName: 'STATUS', field: 'statusSolicitacaoUpload', width: 120 },                                                        
            { headerName: '' , field: 'numero', cellRendererFramework: BtnAggridRequestComponentRenderer, colId: 'colRequest', editable: false, width: 40},          
            { headerName: '' , field: 'numero', cellRendererFramework: BtnAggridDownloadComponentRenderer, colId: 'colDownload', editable: false, width: 40},     
          ]
      },
      popupListaArquivos: { 
        tr: null, 
        numeroCamera: null,
        popupActive:false,
        listaArquivosVideo: []
      },
      popUpCameras: {        
        camera1: "",
        camera2: "",
        camera3: "",
        camera4: "",
        camera5: "",
        labelCamera1: "",
        labelCamera2: "",
        labelCamera3: "",
        labelCamera4: "",
        labelCamera5: "",        
        mensagem: null,
        exibirMensagem: false        
      },      
      isLoading1: false,
      isLoading2: false,
      isLoading3: false,
      isLoading4: false,
      isLoading5: false,
      pollingIntervalObj: null,
      listaSource: [],
      veiculos: [],
      selected: [],      
      isMounted: false,      
      switchEnderecoCidade: true,      
      cmbDivisao: null,      
      termoPesquisa: null, 
      colunasGrid: {
        veiculo: true,
        ignicaoBloqueio: true,
        statusConexaoStatusAlimentacao:  true,
        placaKmHorimetro:  true,
        motorista:  true,
        velocidadeTempoParado: true,
        sensores: true,
        localizacaoUltimaAtualizacao: true,
        capacidadePeso: false,
        capacidadeVolume: false,						
        condutor: false,
        autonomia: false,
        autonomiaPorHora: false,
        latitude: false,
        longitude: false,
        placa: false,
        panico: false,
        dataHoraPanico: false,
        ignicao: false,
        statusPanico: false,
        idVeiculo: false,
        codigoModulo: false,
        marca: false,
        modelo: false,
        tipoVeiculo: false,
        divisaoVeiculo: false,
        corNomeDivisao: false,
        velocidadeAtual: false,
        dataUltimoPacoteRecebido: false,
        dataUltimaAtualizacaoFmt2: false,
        tempoSemGPRS: false,
        tempoParadoEmMinutos: false,
        isDesatualizado: false,
        orientacao: false,
        possuiBloqueio: false,
        statusGPRS:  false,
        isBloqueado:  false,
        ultimoOdometro:  false,
        ultimoOdometroBkp:  false,
        ultimoHorimetro: false,
        ultimoHorimetroBkp: false,
        labelVeiculo:  false,
        possuiTeclado:  false,
        possuiSaida2:  false,
        possuiSaida3:  false,
        sensorRS232:  false,
        sensorRS232Instalado:  false,
        avisarVeiculoLigado:  false,
        avisarVeiculoDesligado:  false,
        statusAncoragem:  false,
        ultimaVoltagem:  false,
        semAlimentacaoExterna:  false,
        nivelBateriaModulo: false,
        nivelBateriaModuloBkp:  false,
        avisoAux0:  false,
        avisoAux1:  false,
        avisoAux2:  false,
        statusEntrada1:  false,
        statusEntrada2: false,
        statusEntrada3: false,
        statusEntrada4: false,
        statusSaida1:  false,
        statusSaida2: false,
        statusSaida3:  false,
        corVeiculo:  false,
        ultimoRPM:  false,
        localizacao: false
      }
    }
  },
  beforeDestroy() {
    this.selected = null;        
    this.veiculos = null;
    clearInterval(this.pollingIntervalObj);
        
    this.$refs.refPlayer_1.destroy();  
    this.$refs.refPlayer_2.destroy();
    this.$refs.refPlayer_3.destroy();
    this.$refs.refPlayer_4.destroy();
    this.$refs.refPlayer_5.destroy(); 
  },
  computed: {            
    listaDivisao() {
      return this.$store.state.listaDivisao;
    },
    corCadeado() {
      return {
         'text-white': (this.$store.state.theme === 'dark'),
         'text-black': (this.$store.state.theme === 'light'),
      }
    },
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },    
    corLocalidades() {
      return this.$store.state.corLocalidade;
    },  
    queriedItems: function () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.veiculos.length
    },
    filteredVeiculos: function () {
        var self = this;
        var arrayRetorno = self.veiculos;

        arrayRetorno = arrayRetorno.filter(function (tr) {
          return tr.marcaModulo.indexOf('JIMI_HUB') !== -1 || ( tr.marcaModuloBkp && tr.marcaModuloBkp.indexOf('JIMI_HUB') !== -1);
        });
         
        arrayRetorno = arrayRetorno.filter(function (veiculo) {
            let termoUC = ( self.termoPesquisa != null ? self.termoPesquisa.toUpperCase() : null);
            return (self.cmbDivisao != null ? self.cmbDivisao == veiculo.divisaoVeiculo : true)            
            && (termoUC ? (veiculo.marca.toUpperCase().indexOf(termoUC) != -1 || veiculo.modelo.toUpperCase().indexOf(termoUC) != -1 ||
                        veiculo.divisaoVeiculo.toUpperCase().indexOf(termoUC) != -1 || veiculo.cidadeAtual.toUpperCase().indexOf(termoUC) != -1 ||
                        veiculo.condutor.toUpperCase().indexOf(termoUC) != -1 || (veiculo.labelVeiculo && veiculo.labelVeiculo.toUpperCase().indexOf(termoUC) != -1)
                        || veiculo.placa.toUpperCase().indexOf(termoUC) != -1): true);
        })

        return arrayRetorno;
    },      
  },
  methods: {   
    pararCamera(numeroCamera) {
      if (numeroCamera === 1) {
        this.popUpCameras.labelCamera1 = null;
        this.popUpCameras.camera1 = null;        
        this.$refs.refPlayer_1.destroy();
      } else if (numeroCamera === 2) {
        this.popUpCameras.labelCamera2 = null;
        this.popUpCameras.camera2 = null;        
        this.$refs.refPlayer_2.destroy();        
      } else if (numeroCamera === 3) {
        this.popUpCameras.labelCamera3 = null;
        this.popUpCameras.camera3 = null;        
        this.$refs.refPlayer_3.destroy();        
      } else if (numeroCamera === 4) {
        this.popUpCameras.labelCamera4 = null;
        this.popUpCameras.camera4 = null;        
        this.$refs.refPlayer_4.destroy();        
      } else if (numeroCamera === 5) {
        this.popUpCameras.labelCamera5 = null;
        this.popUpCameras.camera5 = null;        
        this.$refs.refPlayer_5.destroy();        
      }
    },
    onGridReady() {            
        this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;       
        this.configuracaoGrid.gridColumnApi = this.configuracaoGrid.gridOptions.columnApi;                    
        this.configuracaoGrid.gridApi.sizeColumnsToFit();   
    },
    downloadFile(tr)  {            
      const link = document.createElement('a')
      if (tr.hasOwnProperty('fileName')) {
        link.href = "https://cpt-vt-videos-jimi.s3.amazonaws.com/" + tr.imei + "/" + tr.fileName;
      } else {
        if ("JC181" === this.popupListaArquivos.tr.modeloCamera) {
          //CH1_250219_144917_000000.mp4
          let vData = String(tr.beginTime).substring(0,6);
          let vHora = String(tr.beginTime).substring(6);
          link.href = "https://media.telemetria.concept.inf.br/downloadVT/" + tr.imei.substring(1) + "/CH" + tr.channel + "_" + vData + "_" + vHora + "_000000.mp4";
        } else {
          link.href = "https://media.telemetria.concept.inf.br/downloadVT/" + tr.imei.substring(1) + "/" + this.getLetter(tr.channel) + "20" + tr.beginTime + this.getSufixo() + ".ts";
        }
      }
      
      link.setAttribute('target', '_blank');
      link.download = "Arquivo";
      link.click();
      URL.revokeObjectURL(link.href);
    },
    getLetter(numeroCamera) {
      if (numeroCamera == 1) { return 'F'}
      else if (numeroCamera == 2) { return 'L'}
      else if (numeroCamera == 3) { return 'B'}
      else if (numeroCamera == 4) { return 'R'}
      else if (numeroCamera == 5) { return 'S'}
      return 'F';
    },
    getSufixo() {
        if ("v2" === this.popupListaArquivos.tr.versaoFirmware) {
          return "_GMT-03I00";
        }
        return "";
    },
    requisitarUploadArquivosVideo(trArquivo) {
      
      this.$vs.loading();
      
      const params = new URLSearchParams();              
      params.append('acao', "REQUISITAR_ARQUIVO_VIDEO_CAMERAS");
      params.append('imei', trArquivo.imei.substring(1));      
      params.append('numeroCamera', trArquivo.channel);      
      params.append('beginTime', trArquivo.beginTime);      
      params.append('endTime', trArquivo.endTime);      
      params.append('alarmFlag', trArquivo.alarmFlag);      
      params.append('resourceType', trArquivo.resourceType);      
      params.append('codeType', trArquivo.codeType);      
      params.append('storageType', trArquivo.storageType);      
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      params.append('idVeiculo', this.popupListaArquivos.tr.idVeiculo);
      params.append('instructionID', trArquivo.id);
      
      axios.post('/EnviarComandoModulo', params, {              
              credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
      .then((response) => {          
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
            this.$router.push({ path: '/login' });
          } else {       
              if (response.data.code === 100) {             
              this.$vs.notify({
                      time:8000, title: "Atenção",  text: response.data.mensagem,
                      iconPack: 'feather', icon: 'icon-alert-circle', color: 'success'
              });       
              this.fetchListaArquivosMedia(this.popupListaArquivos.tr, trArquivo.channel);
            } else {
              this.$vs.notify({
                      time:8000, title: "Atenção",  text: response.data.mensagem,
                      iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger'
              });       
            }
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          console.log("ERRO - consultarListaArquivosVideo - " + error);         
      })
    },
    abrirPopUp(tr, numeroCamera){
      this.$vs.loading();
      this.popupListaArquivos.popupActive = true;
      this.popupListaArquivos.tr = tr;
      this.popupListaArquivos.numeroCamera = numeroCamera;
      this.popupListaArquivos.listaArquivosVideo = [];
      this.fetchListaArquivosMedia(tr, numeroCamera);
    },  
    exibirUltimaLista(tr, channel) {
        this.$vs.loading();
        this.fetchListaArquivosMedia(tr, channel);
    },
    fetchListaArquivosMedia(tr, channel) {       
      let imei = "";

      if (tr.marcaModulo.indexOf('JIMI_HUB') !== -1) {
        imei = tr.codigoModulo;
      } else if (tr.marcaModuloBkp && tr.marcaModuloBkp.indexOf('JIMI_HUB') !== -1) {
        imei = tr.codigoModuloBkp;
      } else  {       
        this.$vs.loading.close();
        return;
      }

      const params = new URLSearchParams();
      params.append('cliente.id', this.$store.state.AppActiveUser.id);
      params.append('imei', imei);      
      params.append('channel', channel);
      params.append('modeloCamera', tr.modeloCamera);
      
      axios.post("/rest/ArquivosVideoTelemetria/Listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              
              if (response.data.Resultado.quantidade > 1) {
                  this.popupListaArquivos.listaArquivosVideo = response.data.Resultado.lista.item;
              } else if (response.data.Resultado.quantidade === 1) {
                  this.popupListaArquivos.listaArquivosVideo = [];
                  this.popupListaArquivos.listaArquivosVideo.push(response.data.Resultado.lista.item);
              } else {
                  this.popupListaArquivos.listaArquivosVideo = [];
              }                             
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaPoI - " + error); 
      })    
                        
    },   
    requisitarNovaListaArquivosVideo(tr, numeroCamera) {
      let imei = "";

      if (tr.marcaModulo.indexOf('JIMI_HUB') !== -1) {
        imei = tr.codigoModulo.substring(1);
      } else if (tr.marcaModuloBkp && tr.marcaModuloBkp.indexOf('JIMI_HUB') !== -1) {
        imei = tr.codigoModuloBkp.substring(1);
      } else  {       
        return;
      }

      this.$vs.loading();
      const params = new URLSearchParams();              
      params.append('acao', "CONSULTAR_ARQUIVOS_VIDEO_CAMERA");
      params.append('imei', imei);      
      params.append('numeroCamera', numeroCamera);      
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      params.append('idVeiculo', tr.idVeiculo);
      
      axios.post('/EnviarComandoModulo', params, {              
              credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
      .then((response) => {   
          this.$vs.loading.close();       
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
            this.$router.push({ path: '/login' });
          } else {        
            if (response.data.code === 100) {   
              this.$vs.notify({
                      time:8000, title: "Atenção",  text: response.data.mensagem,
                      iconPack: 'feather', icon: 'icon-alert-circle', color: 'success'
              });   
            } else {          
              this.$vs.notify({
                      time:8000, title: "Atenção",  text: response.data.mensagem,
                      iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger'
              });   
            }    
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();       
          console.log("ERRO - consultarListaArquivosVideo - " + error);         
      })
    },
    consultarQtdCameras(tr) {
      let imei = "";

      if (tr.marcaModulo.indexOf('JIMI_HUB') !== -1) {
        imei = tr.codigoModulo.substring(1);
      } else if (tr.marcaModuloBkp && tr.marcaModuloBkp.indexOf('JIMI_HUB') !== -1) {
        imei = tr.codigoModuloBkp.substring(1);
      } else  {       
        return;
      }

      const params = new URLSearchParams();              
      params.append('acao', "CONSULTAR_NUMERO_VIDEO_CAMERAS");
      params.append('imei', imei);      
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      params.append('idVeiculo', tr.idVeiculo);
      
      axios.post('/EnviarComandoModulo', params, {              
              credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
      .then((response) => {          
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
              this.$router.push({ path: '/login' });
          } else {     
              this.$set(tr, 'qtdCameras', response.data.qtdCameras);              
              this.$set(tr, 'modeloCamera', response.data.modeloCamera);         
              this.$set(tr, 'versaoFirmware', response.data.versaoFirmware);                            
          }
      })
      .catch((error) => { 
          console.log("ERRO - consultarQtdCameras - " + error);         
      })
    },
    abrirCamera(tr, numeroCamera) {
      this.popUpCameras.mensagem = null;
      this.popUpCameras.exibirMensagem = false;
      
      if (tr.marcaModulo.indexOf('JIMI_HUB') === -1 && ( !tr.marcaModuloBkp || tr.marcaModuloBkp.indexOf('JIMI_HUB') === -1)) {         
        this.$vs.dialog({ color: 'danger', title: this.$t('Atencao'), text: "Veículo sem câmeras instaladas.", acceptText: this.$t('Btn_OK')});
        return;
      }

      // if (tr.ignicao === 'DESLIGADO') {
      //     this.$vs.dialog({ color: 'danger', title: this.$t('Atencao'), text: "Veículo desligado. As câmeras não podem ser visualizadas.", acceptText: this.$t('Btn_OK')})                
      //     return;
      // }

      let imei = "";

      if (tr.marcaModulo.indexOf('JIMI_HUB') !== -1) {
          imei = tr.codigoModulo.substring(1);
      } else if (tr.marcaModuloBkp  && tr.marcaModuloBkp.indexOf('JIMI_HUB') !== -1) {
         imei = tr.codigoModuloBkp.substring(1);
      } else  {
        this.$vs.dialog({ color: 'danger', title: this.$t('Atencao'), text: "Veículo sem câmeras instaladas.", acceptText: this.$t('Btn_OK')});
        return;
      }
 
      const params = new URLSearchParams();              
      params.append('acao', "SOLICITAR_VIDEO_CAMERAS");
      params.append('imei', imei);
      params.append('numeroCamera', numeroCamera);      
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      params.append('idVeiculo', tr.idVeiculo);

      if (numeroCamera == 1) {
        this.isLoading1 = true;
        this.popUpCameras.labelCamera1 = tr.placa;
      } else if (numeroCamera == 2) {
        this.isLoading2 = true;
        this.popUpCameras.labelCamera2 = tr.placa;
      } else if (numeroCamera == 3) {
        this.isLoading3 = true;
        this.popUpCameras.labelCamera3 = tr.placa;
      } else if (numeroCamera == 4) {
        this.isLoading4 = true;
        this.popUpCameras.labelCamera4 = tr.placa;
      }else if (numeroCamera == 5) {
        this.isLoading5 = true;
        this.popUpCameras.labelCamera5 = tr.placa;
      }
      
      axios.post('/EnviarComandoModulo', params, {              
              credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
      .then((response) => {
          if (numeroCamera == 1 || response.data.tipo_modulo == 'JC400') {
            this.isLoading1 = false;            
          } else if (numeroCamera == 2) {
            this.isLoading2 = false;            
          } else if (numeroCamera == 3) {
            this.isLoading3 = false;            
          } else if (numeroCamera == 4) {
            this.isLoading4 = false;            
          }else if (numeroCamera == 5) {
            this.isLoading5 = false;            
          }
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
              this.$router.push({ path: '/login' });
          } else {     
              if (response.data.code === 100) {              
                this.popUpCameras.mensagem = null;
                this.popUpCameras.exibirMensagem = false;
                if (numeroCamera === 1 || response.data.tipo_modulo == 'JC400')  {                                        
                    if (this.popUpCameras.camera1) {
                      this.$refs.refPlayer_1.destroy();                      
                    }
                     if (response.data.tipo_modulo == 'JC400AD' || response.data.tipo_modulo == 'JC400P') {
                      this.popUpCameras.camera1 = "https://jimihub.concept.inf.br/live/0/"+ imei + ".flv";
                    } else if (response.data.tipo_modulo == 'JC400' || response.data.tipo_modulo == 'JC400D') {
                      this.popUpCameras.camera1 = "https://jimihub.concept.inf.br/live/"+ imei + ".flv";
                    } else {
                      this.popUpCameras.camera1 = "https://jimihub.concept.inf.br/" + numeroCamera + "/"+ imei + ".flv";
                    }
                    this.popUpCameras.labelCamera1 = tr.placa;
                    this.$refs.refPlayer_1.load();
                    this.$refs.refPlayer_1.play();
                } else if (numeroCamera === 2)  {
                    if (this.popUpCameras.camera2) {
                      this.$refs.refPlayer_2.destroy();                      
                    }
                    if (response.data.tipo_modulo == 'JC400AD' || response.data.tipo_modulo == 'JC400P') {
                      this.popUpCameras.camera2 = "https://jimihub.concept.inf.br/live/1/"+ imei + ".flv";
                    } else {
                      this.popUpCameras.camera2 = "https://jimihub.concept.inf.br/" + numeroCamera + "/"+ imei + ".flv";
                    }
                    this.popUpCameras.labelCamera2 = tr.placa;
                    this.$refs.refPlayer_2.load();
                    this.$refs.refPlayer_2.play();
                                        
                } else if (numeroCamera === 3)  {
                    if (this.popUpCameras.camera3) {
                      this.$refs.refPlayer_3.destroy();                      
                    }
                    this.popUpCameras.camera3 = "https://jimihub.concept.inf.br/" + numeroCamera + "/"+ imei + ".flv";
                    this.popUpCameras.labelCamera3 = tr.placa;
                    this.$refs.refPlayer_3.load();
                    this.$refs.refPlayer_3.play();
                } else if (numeroCamera === 4)  {
                    if (this.popUpCameras.camera4) {
                      this.$refs.refPlayer_4.destroy();                      
                    }
                    this.popUpCameras.camera4 = "https://jimihub.concept.inf.br/" + numeroCamera + "/"+ imei + ".flv";
                    this.popUpCameras.labelCamera4 = tr.placa;
                    this.$refs.refPlayer_4.load();
                    this.$refs.refPlayer_4.play();
                } else if (numeroCamera === 5)  {
                    if (this.popUpCameras.camera5) {
                      this.$refs.refPlayer_5.destroy();                      
                    }
                    this.popUpCameras.camera5 = "https://jimihub.concept.inf.br/" + numeroCamera + "/"+ imei + ".flv";
                    this.popUpCameras.labelCamera5 = tr.placa;
                    this.$refs.refPlayer_5.load();
                    this.$refs.refPlayer_5.play();
                }
              } else {
                if (this.popUpCameras.camera1) {
                    this.$refs.refPlayer_1.destroy();
                    this.popUpCameras.labelCamera1 = null;
                }
                if (this.popUpCameras.camera2) {
                    this.$refs.refPlayer_2.destroy();
                    this.popUpCameras.labelCamera2 = null;
                }
                if (this.popUpCameras.camera3) {
                    this.$refs.refPlayer_3.destroy();
                    this.popUpCameras.labelCamera3 = null;
                }
                if (this.popUpCameras.camera4) {
                  this.$refs.refPlayer_4.destroy();
                  this.popUpCameras.labelCamera4 = null;
                }
                if (this.popUpCameras.camera5) {
                  this.$refs.refPlayer_5.destroy();
                  this.popUpCameras.labelCamera5 = null;
                }
                this.popUpCameras.mensagem = response.data.mensagem;
                this.popUpCameras.exibirMensagem = true;
              }                            
          }
      })
      .catch((error) => { 
         if (numeroCamera == 1) {
            this.isLoading1 = false;
          } else if (numeroCamera == 2) {
            this.isLoading2 = false;
          } else if (numeroCamera == 3) {
            this.isLoading3 = false;
          } else if (numeroCamera == 4) {
            this.isLoading4 = false;
          }else if (numeroCamera == 5) {
            this.isLoading5 = false;
          }
          console.log("EFETUAR LOGOFF! - abrirCamera - " + error); 
          this.$vs.loading.close();         
      }) 
    },
    isPossuiRPM(dataObj) {
            return (dataObj.ultimoRPM);
    },
    ordenarPorCampo(a,b,campo) {
      const nameA = a[campo].toUpperCase();
      const nameB = b[campo].toUpperCase();
      return nameA.localeCompare(nameB);      
    },      
    ordenarTabela(key) {      
      let _self = this;   
      this.veiculos.sort((a,b) => {
            _self.ordenarPorCampo(a,b,key);
      });         
    },
    pesquisarPorTermo(valorTermo){
        this.termoPesquisa = valorTermo;            
        this.exibirVeiculosListados();
    },
    formatarValorPara2Digitos(valor){
      return generico.formatar2Digitos(valor);
    },
    decode0e1_AtivoInativo(valor) {
      return (valor === '1' ? 'ATIVO': 'INATIVO');
    },
    decodeTrueeFalse_SimNao(valor) {
      return (valor === 'true' ? 'SIM': 'NÃO');
    },
    getCampoOrdenacao() {
      return "ultimaVoltagem";
    },
    getCorCargaBateria(carga) {
        if (carga < 40) {
            return "rgb(255,15,15)";
        } else {
            return "rgb(70, 150, 0)";
        }
    },
    getCorAtivoInativo(status) {
        if (status) {
            return "rgb(70, 150, 0)";
        } else {
            return "rgb(255,15,15)";
        }
    },
    getCor2AtivoInativo(status) {
        if (status) {
            return "rgb(95, 219, 167)";
        } else {
            return "rgb(128,128,128)";
        }
    },      
    getCorLinha(dataObj) {
        let retorno = "";
        if (dataObj) {          
          var arrayCores = this.corLocalidades.filter(function (cor) {
            return cor.localidade == dataObj.cidadeAtual.toUpperCase();
          });

          if (arrayCores != null && arrayCores.length > 0) {
            
            if (generico.isDarkColor(arrayCores[0].corEmHexa)) {
                retorno =  "color: #eeeeee; background-color: " + arrayCores[0].corEmHexa;    
            } else {
                retorno = "background-color: " + arrayCores[0].corEmHexa;
            }

            arrayCores = null;
          } else {
            retorno = "";
          } 
        }
        return retorno;
    },        
    getLabelDadosPlaca(dataObj) {            
      if (dataObj.hasOwnProperty('labelVeiculo')) {
          return "<p title='ID:" + dataObj.idVeiculo + "' onclick=\"click_ExibiVeiculo('" + dataObj.placa + "')\" style='font-size:small; font-weight: 500'>" + dataObj.labelVeiculo + "</p>" 
          + "<p style='font-size:x-small'>" + (parseInt(dataObj.ultimoOdometroBkp) > 0 ? '[KM1: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometro) / 1000) + '] [KM2: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometroBkp) / 1000) + ']' : 'KM: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometro) / 1000)) + "</p>"
          + "<p style='font-size:x-small'>" + (parseInt(dataObj.ultimoHorimetroBkp) > 0 ? '[H1: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoHorimetro) / 60) + '] [H2: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoHorimetroBkp) / 60) + ']' : 'H: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoHorimetro) / 60)) + "</p>";
      } else {
          return "<p title='ID:" + dataObj.idVeiculo + "' onclick=\"click_ExibiVeiculo('" + dataObj.placa + "')\" style='font-size:small; font-weight: 500'>" + dataObj.placa + "</p>" 
          + "<p style='font-size: x-small'>" + (parseInt(dataObj.ultimoOdometroBkp) > 0 ? '[KM1: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometro) / 1000) + '] [KM2: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometroBkp) / 1000) + ']' : 'KM: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoOdometro) / 1000)) + "</p>"
          + "<p style='font-size:x-small'>" + (parseInt(dataObj.ultimoHorimetroBkp) > 0 ? '[H1: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoHorimetro) / 60) + '] [H2: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoHorimetroBkp) / 60) + ']' : 'H: ' + generico.formatar2Digitos(parseInt(dataObj.ultimoHorimetro) / 60)) + "</p>";
      }
    },
    getLabelDadosDivisao(dataObj) {
      if (dataObj.divisaoVeiculo != "OUTRO") {
        return "<p style='font-size:small; color: " + dataObj.corNomeDivisao+ "'>" + dataObj.divisaoVeiculo + "</p>" + "<p style='color: " + dataObj.corNomeDivisao+ "'>" + dataObj.modelo + "</p>";
      } else {
        return "<p style='font-size:small'>" + dataObj.modelo + "</p>";
      }
    },
    isMovendo(dataObj) {
        return (dataObj.ignicao == 'LIGADO' ? (parseInt(dataObj.velocidadeAtual) > 0 ? true : false) :  false);
    },    
    getLabelVelocidadeEParado(dataObj) {
				return (dataObj.ignicao == 'LIGADO' ? (parseInt(dataObj.velocidadeAtual) > 0 ? dataObj.velocidadeAtual + ' km/h' : dataObj.tempoParado) :  dataObj.tempoParado);
    },      
    getLabelLocalizacao(dataObj)  {
				if (dataObj.hasOwnProperty("poi")) {
					return dataObj.poi;
				} else {		
          if (this.switchEnderecoCidade) {
              return dataObj.enderecoAtual;
          }	 else {
              return dataObj.cidadeAtual.toUpperCase();
          }
				}				    
    },
    getDataUltimaAtualizacao(dataObj) {
      return (dataObj.dataUltimaAtualizacaoFmt2 != "null" ? dataObj.dataUltimaAtualizacaoFmt2 : "-");
    },    
    pollVeiculos(){
      if (this.pollingIntervalObj === null) {
        this.fetchVeiculos();
      }

      let _self = this;
      this.pollingIntervalObj = setInterval(() => {     
          _self.fetchVeiculos();
      }, 10000);
    },   
    fetchVeiculos(){
        const params = new URLSearchParams();
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);

        axios.post("/RastrearVeiculosCliente", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
              if (!response.data.hasOwnProperty("codigo") || response.data.codigo !== "99" ) {            
                this.atualizarDadosListaVeiculos(response.data)            
              }            
        })
        .catch((error) => { 
              console.log(error);
        })
    },
    atualizarDadosListaVeiculos(pVeiculos) {
        if (Array.isArray(this.veiculos) && this.veiculos.length ) {      
        try {
            this.veiculos.forEach((va) => {                
              pVeiculos.every((vn) => {        
                if (va.placa === vn.placa) {

                  if (va.condutor !== vn.condutor) {
                    va.condutor = vn.condutor;
                  }

                  if ((va.latitude != vn.latitude) || (va.longitude != vn.longitude)) {										                  
                    va.latitude = vn.latitude;
                    va.longitude = vn.longitude;
                  }
                  
                  if (va.ignicao !== vn.ignicao) {
                    va.ignicao = vn.ignicao;
                    va.velocidadeAtual = vn.velocidadeAtual;
                    va.tempoParado = vn.tempoParado;
                  }

                  if (va.velocidadeAtual !== vn.velocidadeAtual) {
                    va.velocidadeAtual = vn.velocidadeAtual;
                    va.tempoParado = vn.tempoParado;
                  }

                  if (va.dataUltimaAtualizacao !== vn.dataUltimaAtualizacao) {
                    va.dataUltimaAtualizacao = vn.dataUltimaAtualizacao;
                  }
                  
                  if (va.dataUltimaAtualizacaoFmt2 !== vn.dataUltimaAtualizacaoFmt2) {
                    va.dataUltimaAtualizacaoFmt2 = vn.dataUltimaAtualizacaoFmt2;
                  }

                  if (va.tempoSemGPRS !== vn.tempoSemGPRS) {
                    va.tempoSemGPRS = vn.tempoSemGPRS;
                  }

                  if (va.tempoParado !== vn.tempoParado) {
                    va.tempoParado = vn.tempoParado;
                  }

                  if (vn.hasOwnProperty("exibirAlertaTempoParado")) {
                    va.exibirAlertaTempoParado = vn.exibirAlertaTempoParado;
                  } else if (va.hasOwnProperty("exibirAlertaTempoParado")) {
                    delete va.exibirAlertaTempoParado;
                  }

                  if (va.isDesatualizado !== vn.isDesatualizado) {
                    va.isDesatualizado = vn.isDesatualizado;
                  }

                  if (va.orientacao !== vn.orientacao) {
                    va.orientacao = vn.orientacao;
                  }
                  
                  if (va.statusGPRS !== vn.statusGPRS) {
                    va.statusGPRS = vn.statusGPRS;
                  }

                  if (va.isBloqueado !== vn.isBloqueado) {
                    va.isBloqueado = vn.isBloqueado;
                  }
                  
                  if (va.cidadeAtual !== vn.cidadeAtual) {
                    va.cidadeAtual = vn.cidadeAtual;
                  }

                  if (va.ultimoOdometro !== vn.ultimoOdometro) {
                    va.ultimoOdometro = vn.ultimoOdometro;
                  }

                  if (va.ultimoOdometroBkp !== vn.ultimoOdometroBkp) {
                    va.ultimoOdometroBkp = vn.ultimoOdometroBkp;
                  }

                  if (vn.hasOwnProperty("labelVeiculo")) {
                    va.labelVeiculo = vn.labelVeiculo;
                  } else  if (va.hasOwnProperty("labelVeiculo")) {
                    delete va.labelVeiculo;
                  }

                  if (vn.hasOwnProperty("sensorRS232")) {                
                    va.sensorRS232 = vn.sensorRS232;
                  } else if (va.hasOwnProperty("sensorRS232")) {  
                    delete va.sensorRS232;
                  }

                  if (vn.hasOwnProperty("poi")) {                
                    va.poi = vn.poi;
                  } else if (va.hasOwnProperty("poi")) {  
                    delete va.poi;
                  }

                  if (va.enderecoAtual !== vn.enderecoAtual) {
                    va.enderecoAtual = vn.enderecoAtual;
                  }

                  if (va.ultimaVoltagem !== vn.ultimaVoltagem) {
                    va.ultimaVoltagem = vn.ultimaVoltagem;
                  }

                  if (va.semAlimentacaoExterna !== vn.semAlimentacaoExterna) {
                    va.semAlimentacaoExterna = vn.semAlimentacaoExterna;
                  }

                  if (vn.hasOwnProperty("nivelBateriaModulo")) {                
                    va.nivelBateriaModulo = vn.nivelBateriaModulo;
                  } else if (va.hasOwnProperty("nivelBateriaModulo")) {  
                    delete va.nivelBateriaModulo;
                  }

                  if (va.bateriaAllModulo !== vn.bateriaAllModulo) {                
                    va.bateriaAllModulo = vn.bateriaAllModulo;
                  } 

                  if (vn.hasOwnProperty("nivelBateriaModuloBkp")) {                
                    va.nivelBateriaModuloBkp = vn.nivelBateriaModuloBkp;
                  } else if (va.hasOwnProperty("nivelBateriaModuloBkp")) {  
                    delete va.nivelBateriaModuloBkp;
                  } 
                  
                  if (va.bateriaAllModuloBkp !== vn.bateriaAllModuloBkp) {                
                    va.bateriaAllModuloBkp = vn.bateriaAllModuloBkp;
                  } 
                  
                  if (vn.hasOwnProperty("avisoAux0")) {                
                    va.avisoAux0 = vn.avisoAux0;
                  } else if (va.hasOwnProperty("avisoAux0")) {  
                    delete va.avisoAux0;
                  }   
                  
                  if (vn.hasOwnProperty("avisoAux1")) {                
                    va.avisoAux1 = vn.avisoAux1;
                  } else if (va.hasOwnProperty("avisoAux1")) {  
                    delete va.avisoAux1;
                  } 

                  if (vn.hasOwnProperty("avisoAux2")) {                
                    va.avisoAux2 = vn.avisoAux2;
                  } else if (va.hasOwnProperty("avisoAux2")) {  
                    delete va.avisoAux2;
                  } 

                  if (va.statusEntrada1 !== vn.statusEntrada1) {
                    va.statusEntrada1 = vn.statusEntrada1;
                  }
                  if (va.statusEntrada2 !== vn.statusEntrada2) {
                    va.statusEntrada2 = vn.statusEntrada2;
                  }
                  if (va.statusEntrada3 !== vn.statusEntrada3) {
                    va.statusEntrada3 = vn.statusEntrada3;
                  }
                  if (va.statusEntrada4 !== vn.statusEntrada4) {
                    va.statusEntrada4 = vn.statusEntrada4;
                  }
                  if (va.statusSaida1 !== vn.statusSaida1) {
                    va.statusSaida1 = vn.statusSaida1;
                  }
                  if (va.statusSaida2 !== vn.statusSaida2) {
                    va.statusSaida2 = vn.statusSaida2;
                  }
                  if (va.statusSaida3 !== vn.statusSaida3) {
                    va.statusSaida3 = vn.statusSaida3;
                  }

                  if (va.ultimoRPM !== vn.ultimoRPM) {
                    va.ultimoRPM = vn.ultimoRPM;
                  } 
                  
                  if (vn.hasOwnProperty("capacidadePeso")) {
                    if (va.capacidadePeso !== vn.capacidadePeso) { va.capacidadePeso = vn.capacidadePeso; }
                  } else if (va.hasOwnProperty("capacidadePeso")) {
                    delete va.capacidadePeso;
                  }
                  if (vn.hasOwnProperty("capacidadeVolume")) {
                      if (va.capacidadeVolume !== vn.capacidadeVolume) { va.capacidadeVolume = vn.capacidadeVolume; }
                  } else if (va.hasOwnProperty("capacidadeVolume")) {
                    delete va.capacidadeVolume;
                  }
                  if (vn.hasOwnProperty("condutor")) {
                      if (va.condutor !== vn.condutor) { va.condutor = vn.condutor; }
                  } else if (va.hasOwnProperty("condutor")) {
                    delete va.condutor;
                  }
                  if (vn.hasOwnProperty("autonomia")) {
                      if (va.autonomia !== vn.autonomia) { va.autonomia = vn.autonomia; }
                  } else if (va.hasOwnProperty("autonomia")) {
                    delete va.autonomia;
                  }
                  if (vn.hasOwnProperty("autonomiaPorHora")) {
                      if (va.autonomiaPorHora !== vn.autonomiaPorHora) { va.autonomiaPorHora = vn.autonomiaPorHora; }
                  } else if (va.hasOwnProperty("autonomiaPorHora")) {
                    delete va.autonomiaPorHora;
                  }
                  if (vn.hasOwnProperty("latitude")) {
                      if (va.latitude !== vn.latitude) { va.latitude = vn.latitude; }
                  } else if (va.hasOwnProperty("latitude")) {
                    delete va.latitude;
                  }
                  if (vn.hasOwnProperty("longitude")) {
                      if (va.longitude !== vn.longitude) { va.longitude = vn.longitude; }
                  } else if (va.hasOwnProperty("longitude")) {
                    delete va.longitude;
                  }
                  if (vn.hasOwnProperty("placa")) {
                      if (va.placa !== vn.placa) { va.placa = vn.placa; }
                  } else if (va.hasOwnProperty("placa")) {
                    delete va.placa;
                  }
                  if (vn.hasOwnProperty("panico")) {
                      if (va.panico !== vn.panico) { va.panico = vn.panico; }
                  } else if (va.hasOwnProperty("panico")) {
                    delete va.panico;
                  }
                  if (vn.hasOwnProperty("dataHoraPanico")) {
                      if (va.dataHoraPanico !== vn.dataHoraPanico) { va.dataHoraPanico = vn.dataHoraPanico; }
                  } else if (va.hasOwnProperty("dataHoraPanico")) {
                    delete va.dataHoraPanico;
                  }
                  if (vn.hasOwnProperty("ignicao")) {
                      if (va.ignicao !== vn.ignicao) { va.ignicao = vn.ignicao; }
                  } else if (va.hasOwnProperty("ignicao")) {
                    delete va.ignicao;
                  }
                  if (vn.hasOwnProperty("statusPanico")) {
                      if (va.statusPanico !== vn.statusPanico) { va.statusPanico = vn.statusPanico; }
                  } else if (va.hasOwnProperty("statusPanico")) {
                    delete va.statusPanico;
                  }
                  if (vn.hasOwnProperty("idVeiculo")) {
                      if (va.idVeiculo !== vn.idVeiculo) { va.idVeiculo = vn.idVeiculo; }
                  } else if (va.hasOwnProperty("idVeiculo")) {
                    delete va.idVeiculo;
                  }
                  if (vn.hasOwnProperty("codigoModulo")) {
                      if (va.codigoModulo !== vn.codigoModulo) { va.codigoModulo = vn.codigoModulo; }
                  } else if (va.hasOwnProperty("codigoModulo")) {
                    delete va.codigoModulo;
                  }
                  if (vn.hasOwnProperty("marcaModulo")) {
                      if (va.marcaModulo !== vn.marcaModulo) { va.marcaModulo = vn.marcaModulo; }
                  } else if (va.hasOwnProperty("marcaModulo")) {
                    delete va.marcaModulo;
                  }
                  if (vn.hasOwnProperty("marca")) {
                      if (va.marca !== vn.marca) { va.marca = vn.marca; }
                  } else if (va.hasOwnProperty("marca")) {
                    delete va.marca;
                  }
                  if (vn.hasOwnProperty("modelo")) {
                      if (va.modelo !== vn.modelo) { va.modelo = vn.modelo; }
                  } else if (va.hasOwnProperty("modelo")) {
                    delete va.modelo;
                  }
                  if (vn.hasOwnProperty("tipoVeiculo")) {
                      if (va.tipoVeiculo !== vn.tipoVeiculo) { va.tipoVeiculo = vn.tipoVeiculo; }
                  } else if (va.hasOwnProperty("tipoVeiculo")) {
                    delete va.tipoVeiculo;
                  }
                  if (vn.hasOwnProperty("divisaoVeiculo")) {
                      if (va.divisaoVeiculo !== vn.divisaoVeiculo) { va.divisaoVeiculo = vn.divisaoVeiculo; }
                  } else if (va.hasOwnProperty("divisaoVeiculo")) {
                    delete va.divisaoVeiculo;
                  }
                  if (vn.hasOwnProperty("corNomeDivisao")) {
                      if (va.corNomeDivisao !== vn.corNomeDivisao) { va.corNomeDivisao = vn.corNomeDivisao; }
                  } else if (va.hasOwnProperty("corNomeDivisao")) {
                    delete va.corNomeDivisao;
                  }
                  if (vn.hasOwnProperty("velocidadeAtual")) {
                      if (va.velocidadeAtual !== vn.velocidadeAtual) { va.velocidadeAtual = vn.velocidadeAtual; }
                  } else if (va.hasOwnProperty("velocidadeAtual")) {
                    delete va.velocidadeAtual;
                  }
                  if (vn.hasOwnProperty("dataUltimoPacoteRecebido")) {
                      if (va.dataUltimoPacoteRecebido !== vn.dataUltimoPacoteRecebido) { va.dataUltimoPacoteRecebido = vn.dataUltimoPacoteRecebido; }
                  } else if (va.hasOwnProperty("dataUltimoPacoteRecebido")) {
                    delete va.dataUltimoPacoteRecebido;
                  }
                  if (vn.hasOwnProperty("dataUltimoPacoteRecebidoEmMili")) {
                      if (va.dataUltimoPacoteRecebidoEmMili !== vn.dataUltimoPacoteRecebidoEmMili) { va.dataUltimoPacoteRecebidoEmMili = vn.dataUltimoPacoteRecebidoEmMili; }
                  } else if (va.hasOwnProperty("dataUltimoPacoteRecebidoEmMili")) {
                    delete va.dataUltimoPacoteRecebidoEmMili;
                  }
                  if (vn.hasOwnProperty("dataUltimaAtualizacaoFmt2EmMili")) {
                      if (va.dataUltimaAtualizacaoFmt2EmMili !== vn.dataUltimaAtualizacaoFmt2EmMili) { va.dataUltimaAtualizacaoFmt2EmMili = vn.dataUltimaAtualizacaoFmt2EmMili; }
                  } else if (va.hasOwnProperty("dataUltimaAtualizacaoFmt2EmMili")) {
                    delete va.dataUltimaAtualizacaoFmt2EmMili;
                  }
                  if (vn.hasOwnProperty("tempoSemGPRS")) {
                      if (va.tempoSemGPRS !== vn.tempoSemGPRS) { va.tempoSemGPRS = vn.tempoSemGPRS; }
                  } else if (va.hasOwnProperty("tempoSemGPRS")) {
                    delete va.tempoSemGPRS;
                  }
                  if (vn.hasOwnProperty("tempoParadoEmMinutos")) {
                      if (va.tempoParadoEmMinutos !== vn.tempoParadoEmMinutos) { va.tempoParadoEmMinutos = vn.tempoParadoEmMinutos; }
                  } else if (va.hasOwnProperty("tempoParadoEmMinutos")) {
                    delete va.tempoParadoEmMinutos;
                  }
                  if (vn.hasOwnProperty("isDesatualizado")) {
                      if (va.isDesatualizado !== vn.isDesatualizado) { va.isDesatualizado = vn.isDesatualizado; }
                  } else if (va.hasOwnProperty("isDesatualizado")) {
                    delete va.isDesatualizado;
                  }
                  if (vn.hasOwnProperty("orientacao")) {
                      if (va.orientacao !== vn.orientacao) { va.orientacao = vn.orientacao; }
                  } else if (va.hasOwnProperty("orientacao")) {
                    delete va.orientacao;
                  }
                  if (vn.hasOwnProperty("possuiBloqueio")) {
                      if (va.possuiBloqueio !== vn.possuiBloqueio) { va.possuiBloqueio = vn.possuiBloqueio; }
                  } else if (va.hasOwnProperty("possuiBloqueio")) {
                    delete va.possuiBloqueio;
                  }
                  if (vn.hasOwnProperty("statusGPRS")) {
                      if (va.statusGPRS !== vn.statusGPRS) { va.statusGPRS = vn.statusGPRS; }
                  } else if (va.hasOwnProperty("statusGPRS")) {
                    delete va.statusGPRS;
                  }
                  if (vn.hasOwnProperty("isBloqueado")) {
                      if (va.isBloqueado !== vn.isBloqueado) { va.isBloqueado = vn.isBloqueado; }
                  } else if (va.hasOwnProperty("isBloqueado")) {
                    delete va.isBloqueado;
                  }
                  if (vn.hasOwnProperty("ultimoOdometro")) {
                      if (va.ultimoOdometro !== vn.ultimoOdometro) { va.ultimoOdometro = vn.ultimoOdometro; }
                  } else if (va.hasOwnProperty("ultimoOdometro")) {
                    delete va.ultimoOdometro;
                  }
                  if (vn.hasOwnProperty("ultimoOdometroBkp")) {
                      if (va.ultimoOdometroBkp !== vn.ultimoOdometroBkp) { va.ultimoOdometroBkp = vn.ultimoOdometroBkp; }
                  } else if (va.hasOwnProperty("ultimoOdometroBkp")) {
                    delete va.ultimoOdometroBkp;
                  }
                  if (vn.hasOwnProperty("ultimoHorimetro")) {
                      if (va.ultimoHorimetro !== vn.ultimoHorimetro) { va.ultimoHorimetro = vn.ultimoHorimetro; }
                  } else if (va.hasOwnProperty("ultimoHorimetro")) {
                    delete va.ultimoHorimetro;
                  }
                  if (vn.hasOwnProperty("ultimoHorimetroBkp")) {
                      if (va.ultimoHorimetroBkp !== vn.ultimoHorimetroBkp) { va.ultimoHorimetroBkp = vn.ultimoHorimetroBkp; }
                  } else if (va.hasOwnProperty("ultimoHorimetroBkp")) {
                    delete va.ultimoHorimetroBkp;
                  }
                  if (vn.hasOwnProperty("labelVeiculo")) {
                      if (va.labelVeiculo !== vn.labelVeiculo) { va.labelVeiculo = vn.labelVeiculo; }
                  } else if (va.hasOwnProperty("labelVeiculo")) {
                    delete va.labelVeiculo;
                  }
                  if (vn.hasOwnProperty("possuiTeclado")) {
                      if (va.possuiTeclado !== vn.possuiTeclado) { va.possuiTeclado = vn.possuiTeclado; }
                  } else if (va.hasOwnProperty("possuiTeclado")) {
                    delete va.possuiTeclado;
                  }
                  if (vn.hasOwnProperty("possuiSaida2")) {
                      if (va.possuiSaida2 !== vn.possuiSaida2) { va.possuiSaida2 = vn.possuiSaida2; }
                  } else if (va.hasOwnProperty("possuiSaida2")) {
                    delete va.possuiSaida2;
                  }
                  if (vn.hasOwnProperty("possuiSaida3")) {
                      if (va.possuiSaida3 !== vn.possuiSaida3) { va.possuiSaida3 = vn.possuiSaida3; }
                  } else if (va.hasOwnProperty("possuiSaida3")) {
                    delete va.possuiSaida3;
                  }
                  if (vn.hasOwnProperty("sensorRS232")) {
                      if (va.sensorRS232 !== vn.sensorRS232) { va.sensorRS232 = vn.sensorRS232; }
                  } else if (va.hasOwnProperty("sensorRS232")) {
                    delete va.sensorRS232;
                  }
                  if (vn.hasOwnProperty("sensorRS232Instalado")) {
                      if (va.sensorRS232Instalado !== vn.sensorRS232Instalado) { va.sensorRS232Instalado = vn.sensorRS232Instalado; }
                  } else if (va.hasOwnProperty("sensorRS232Instalado")) {
                    delete va.sensorRS232Instalado;
                  }
                  if (vn.hasOwnProperty("avisarVeiculoLigado")) {
                      if (va.avisarVeiculoLigado !== vn.avisarVeiculoLigado) { va.avisarVeiculoLigado = vn.avisarVeiculoLigado; }
                  } else if (va.hasOwnProperty("avisarVeiculoLigado")) {
                    delete va.avisarVeiculoLigado;
                  }
                  if (vn.hasOwnProperty("avisarVeiculoDesligado")) {
                      if (va.avisarVeiculoDesligado !== vn.avisarVeiculoDesligado) { va.avisarVeiculoDesligado = vn.avisarVeiculoDesligado; }
                  } else if (va.hasOwnProperty("avisarVeiculoDesligado")) {
                    delete va.avisarVeiculoDesligado;
                  }
                  if (vn.hasOwnProperty("statusAncoragem")) {
                      if (va.statusAncoragem !== vn.statusAncoragem) { va.statusAncoragem = vn.statusAncoragem; }
                  } else if (va.hasOwnProperty("statusAncoragem")) {
                    delete va.statusAncoragem;
                  }
                  if (vn.hasOwnProperty("ultimaVoltagem")) {
                      if (va.ultimaVoltagem !== vn.ultimaVoltagem) { va.ultimaVoltagem = vn.ultimaVoltagem; }
                  } else if (va.hasOwnProperty("ultimaVoltagem")) {
                    delete va.ultimaVoltagem;
                  }
                  if (vn.hasOwnProperty("semAlimentacaoExterna")) {
                      if (va.semAlimentacaoExterna !== vn.semAlimentacaoExterna) { va.semAlimentacaoExterna = vn.semAlimentacaoExterna; }
                  } else if (va.hasOwnProperty("semAlimentacaoExterna")) {
                    delete va.semAlimentacaoExterna;
                  }
                  if (vn.hasOwnProperty("nivelBateriaModulo")) {
                      if (va.nivelBateriaModulo !== vn.nivelBateriaModulo) { va.nivelBateriaModulo = vn.nivelBateriaModulo; }
                  } else if (va.hasOwnProperty("nivelBateriaModulo")) {
                    delete va.nivelBateriaModulo;
                  }
                  if (vn.hasOwnProperty("nivelBateriaModuloBkp")) {
                      if (va.nivelBateriaModuloBkp !== vn.nivelBateriaModuloBkp) { va.nivelBateriaModuloBkp = vn.nivelBateriaModuloBkp; }
                  } else if (va.hasOwnProperty("nivelBateriaModuloBkp")) {
                    delete va.nivelBateriaModuloBkp;
                  }
                  if (vn.hasOwnProperty("avisoAux0")) {
                      if (va.avisoAux0 !== vn.avisoAux0) { va.avisoAux0 = vn.avisoAux0; }
                  } else if (va.hasOwnProperty("avisoAux0")) {
                    delete va.avisoAux0;
                  }
                  if (vn.hasOwnProperty("avisoAux1")) {
                      if (va.avisoAux1 !== vn.avisoAux1) { va.avisoAux1 = vn.avisoAux1; }
                  } else if (va.hasOwnProperty("avisoAux1")) {
                    delete va.avisoAux1;
                  }
                  if (vn.hasOwnProperty("avisoAux2")) {
                      if (va.avisoAux2 !== vn.avisoAux2) { va.avisoAux2 = vn.avisoAux2; }
                  } else if (va.hasOwnProperty("avisoAux2")) {
                    delete va.avisoAux2;
                  }
                  if (vn.hasOwnProperty("statusEntrada1")) {
                      if (va.statusEntrada1 !== vn.statusEntrada1) { va.statusEntrada1 = vn.statusEntrada1; }
                  } else if (va.hasOwnProperty("statusEntrada1")) {
                    delete va.statusEntrada1;
                  }
                  if (vn.hasOwnProperty("statusEntrada2")) {
                      if (va.statusEntrada2 !== vn.statusEntrada2) { va.statusEntrada2 = vn.statusEntrada2; }
                  } else if (va.hasOwnProperty("statusEntrada2")) {
                    delete va.statusEntrada2;
                  }
                  if (vn.hasOwnProperty("statusEntrada3")) {
                      if (va.statusEntrada3 !== vn.statusEntrada3) { va.statusEntrada3 = vn.statusEntrada3; }
                  } else if (va.hasOwnProperty("statusEntrada3")) {
                    delete va.statusEntrada3;
                  }
                  if (vn.hasOwnProperty("statusEntrada4")) {
                      if (va.statusEntrada4 !== vn.statusEntrada4) { va.statusEntrada4 = vn.statusEntrada4; }
                  } else if (va.hasOwnProperty("statusEntrada4")) {
                    delete va.statusEntrada4;
                  }
                  if (vn.hasOwnProperty("statusSaida1")) {
                      if (va.statusSaida1 !== vn.statusSaida1) { va.statusSaida1 = vn.statusSaida1; }
                  } else if (va.hasOwnProperty("statusSaida1")) {
                    delete va.statusSaida1;
                  }
                  if (vn.hasOwnProperty("statusSaida2")) {
                      if (va.statusSaida2 !== vn.statusSaida2) { va.statusSaida2 = vn.statusSaida2; }
                  } else if (va.hasOwnProperty("statusSaida2")) {
                    delete va.statusSaida2;
                  }
                  if (vn.hasOwnProperty("statusSaida3")) {
                      if (va.statusSaida3 !== vn.statusSaida3) { va.statusSaida3 = vn.statusSaida3; }
                  } else if (va.hasOwnProperty("statusSaida3")) {
                    delete va.statusSaida3;
                  }
                  if (vn.hasOwnProperty("corVeiculo")) {
                      if (va.corVeiculo !== vn.corVeiculo) { va.corVeiculo = vn.corVeiculo; }
                  } else if (va.hasOwnProperty("corVeiculo")) {
                    delete va.corVeiculo;
                  }
                  if (vn.hasOwnProperty("ultimoRPM")) {
                      if (va.ultimoRPM !== vn.ultimoRPM) { va.ultimoRPM = vn.ultimoRPM; }
                  } else if (va.hasOwnProperty("ultimoRPM")) {
                    delete va.ultimoRPM;
                  }
                
                  return false; // para sair do inner loop
                }
                return true;
              });
            });

          } catch(erro1){
            console.log(erro1);            
          }
      } else {              
        this.veiculos = pVeiculos;
        pVeiculos.forEach((vn) => {    
          this.consultarQtdCameras(vn);
        });    
      }

    }
  },
  mounted() {
    this.isMounted = true;         
    this.pollVeiculos();
  },
  beforeMount() {
     this.configuracaoGrid.context = { componentParent: this };    
  },
}
</script>

<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 215px);
  }
</style>

<style lang="scss">
#dados-grid-view {
  
  .vs-con-table {    
    transform: rotateX(180deg);    
   
    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {     
        transform: rotateX(180deg);   
        width: 100%;
      }
    }

    .vs-table--header {      
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      
    }

    .vs-table {      
      transform: rotateX(180deg);            
      border-collapse: separate;
      border-spacing: 0 0.1rem;
      padding: 0 1rem;
    
      tr{        
          box-shadow: 0 4px 10px 0 rgba(0,0,0,.05);
          td{
            padding: 5px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;        
      }
    }

    .clsAlertaTempoParado {
      animation: blink 2s steps(5, start) infinite;
      -webkit-animation: blink 1s steps(5, start) infinite;
    }
    @keyframes blink {
      from { color: rgb(255, 130, 0); }
      to { color: rgb(70, 0, 128); }
    }
    @-webkit-keyframes blink {
      from { color: rgb(255, 130, 0); }
      to { color: rgb(70, 0, 128); }
    }
  }
}


.con-vs-dialog {    
    .vs-dialog {
      min-width: 660px;
      max-width: 1000px;      
    }
}

.con-vs-popup { 
    .vs-popup {
        min-width: 660px;
        max-width: 1000px;      
    }
}

.tabelaComScroll {
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;            
}  

</style>
